import React from 'react';
import Navbar from '../materialcomp/Navbar';
import BuilderDisplay from './BuilderDisplay';

const Build = () => {
    return (
        <>
            <Navbar/>
            <BuilderDisplay/>
        </>
    )
}
export default Build;